import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SvNotificationStatus } from 'sv-chemistry-ng-lib';

@Component({
  selector: 'user-error-modal',
  templateUrl: './user-error-modal.component.html',
  styleUrls: ['./user-error-modal.component.scss']
})
export class UserErrorModalComponent implements OnInit {
  @Input() isShown: boolean = true;
  @Input() sessionExpired: boolean = false;
  @Output() isShownChange: EventEmitter<boolean> = new EventEmitter();
  @Output() confirmed: EventEmitter<boolean> = new EventEmitter();
  @Output() cancelled: EventEmitter<boolean> = new EventEmitter();

 errorStatus: SvNotificationStatus = SvNotificationStatus.Error;

  constructor() { }

  ngOnInit() {
  }

  public modalClosed() : void {
    this.isShownChange.emit(false);
  }

  public cancelClicked() : void {
    this.cancelled.emit(false);
  }

  public continueClicked() : void {
    this.confirmed.emit(true);
  }
}
